import React from 'react';
import { GenericIconProps } from './utils';
import theme from '../utils/theme/theme';

export default function IconUser(props: GenericIconProps) {
  const { scale = 1, stroke = theme.colors.black } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24 * scale}
      height={24 * scale}
      fill="none"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}
